import { GeoSearch, SubjectData } from '@aloft/toolkit-shared';
import { CompsListingsSearchCriteria } from '@aloft/toolkit-shared/lib/api/listings/types';

import { MILES_TO_METERS } from '../../map/constants.ts';
import { InitialCompSearch } from '../types.ts';

const replaceUndefinedWithEmptyString = <T extends Record<string, any>>(obj: T): T => {
  const newObj: Record<string, any> = {};
  Object.keys(obj).forEach((key) => {
    if (obj[key] === undefined) {
      newObj[key] = '';
    } else {
      newObj[key] = obj[key];
    }
  });
  return newObj as T;
}

export const loadExistingSearchCriteria = (
  existingSearchCriteria: CompsListingsSearchCriteria,
  subject: SubjectData,
  getDefaultFormValues: () => InitialCompSearch['body']['search'],
): InitialCompSearch['body']['search'] => {
  const subjectCoords = {
    lon: subject.editableData.propertyIdentification.coordinates?.longitude || 0,
    lat: subject.editableData.propertyIdentification.coordinates?.latitude || 0,
  };
  let geoSearch: GeoSearch;
  if (existingSearchCriteria.coordinates?.length > 2) {
    geoSearch = {
      t: 'polygon',
      coords: existingSearchCriteria.coordinates.map((coordinate) => [
        coordinate.longitude,
        coordinate.latitude,
      ]),
    };
  } else {
    geoSearch = {
      t: 'radius',
      radiusInMeters: existingSearchCriteria.radius
        ? existingSearchCriteria.radius * MILES_TO_METERS
        : MILES_TO_METERS,
      coord: [subjectCoords.lon, subjectCoords.lat],
    };
  }
  const search = {
    filters: {
      ...existingSearchCriteria.filters,
      saleDate: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.saleDate || {}),
      salePrice: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.salePrice || {}),
      gla: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.gla || {}),
      lotSize: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.lotSize || {}),
      yearBuilt: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.yearBuilt || {}),
      bedrooms: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.bedrooms || {}),
      fullBaths: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.fullBaths || {}),
      stories: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.stories || {}),
      garageSpaces: replaceUndefinedWithEmptyString(existingSearchCriteria.filters?.garageSpaces || {}),
    },
    geoSearch,
    matchCriteria: existingSearchCriteria.matchCriteria || getDefaultFormValues().matchCriteria,
  };

  return search as InitialCompSearch['body']['search'];
};
